var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"banner":_vm.response.banner}}),_c('KeyValue',{attrs:{"list":_vm.response.keyValue}}),_c('TeamRow',{attrs:{"team":_vm.response.teamRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }